import React from "react";
import { useNavigate } from "react-router-dom";
import Button from "../components/Button";

import imgRegistrarnuevopaciente from "../images/registrar-nuevo-paciente.png";
import imgMibasededatos from "../images/mi-base-de-datos.png";

export default function Home() {
  const navigate = useNavigate();

  const items = [
    { src: imgRegistrarnuevopaciente, alt: "Registrar nuevo paciente", path: "/registrar-nuevo-paciente" },
    { src: imgMibasededatos, alt: "Mi base de datos", path: "/mi-base-de-datos" },
  ];

  return (
    <div className="p-4 max-w-2xl mx-auto mt-4 grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 place-items-center">
      {items.map(({ src, alt, path }) => (
        <img
          key={path}
          src={src}
          alt={alt}
          onClick={() => navigate(path)}
          className="w-52 sm:w-56 md:w-60 h-52 sm:h-56 md:h-60 object-cover cursor-pointer rounded-2xl shadow hover:scale-105 transition-transform duration-200"
        />
      ))}

      {/* Frase + botón */}
      <div className="flex flex-col items-center gap-4 mt-4 text-white text-center col-span-full">
        <p className="text-gray-700 max-w-md">
          Si solo quiere acceder al contenido de la app, pulse sobre el siguiente botón:
        </p>

        <Button 
          onClick={() => navigate("/contenido")}
          className="bg-white border-4 border-disfagiapp-blue hover:bg-white hover:border-disfagiapp-blue-hover !text-gray-700"
          >
          Seguir sin registrar paciente
        </Button>
      </div>
    </div>
  );
}